import React from "react";
import style from "./congratulations.module.css";

import Confetti from "../../assets/Images/Confetti.png";
import thumbIcon from "../../assets/Images/Icon awesome-thumbs-up.svg";
import { Button } from "../Button/Button";

export const Congratulations = ({
  title = "Congratulations",
  message = "Action has been completed successfully",
  description ,
  buttonTxt,
  clickHandler,
}) => {
  return (
    <div className={style.contianer}>
      <img src={Confetti} className={style.bannerImage} />

      <img className={style.iconImage} src={thumbIcon} />

      <div className={style.title}>{title}</div>
      <div className={style.message}>{message}</div>
      <div className={style.description}>{description}</div>
      {buttonTxt && (
        <Button
          buttonTxt={buttonTxt}
          buttonStyle={style.button}
          clickHandler={clickHandler}
        />
      )}
    </div>
  );
};
